module.exports = __webpack_public_path__ + "static/media/edit-teal.84f61c85.svg";